"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Gallery = void 0;
var react_1 = __importDefault(require("react"));
var constants_1 = require("../constants");
var colors_1 = require("../../colors");
var Gallery = function (_a) {
    var color = _a.color, height = _a.height, size = _a.size, width = _a.width;
    return (react_1.default.createElement("svg", { width: width || size || constants_1.DEFAULT_ICON_SIZE, height: height || size || constants_1.DEFAULT_ICON_SIZE, viewBox: '0 0 25 25', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react_1.default.createElement("rect", { x: '1.15234', y: '0.856445', width: '22.7611', height: '22.5', rx: '3.25', stroke: color ? (0, colors_1.getColor)(color) : 'currentColor', strokeWidth: '1.5' }),
        react_1.default.createElement("path", { d: 'M0.848633 16.671L7.87019 10.5569C8.26675 10.2116 8.86297 10.2324 9.23451 10.6045L13.9293 15.3061C14.2764 15.6538 14.8248 15.6978 15.2229 15.4099L17.5334 13.7389C17.9478 13.4393 18.5214 13.5005 18.8632 13.8808L24.0866 19.693', stroke: color ? (0, colors_1.getColor)(color) : 'currentColor', strokeWidth: '1.5' }),
        react_1.default.createElement("circle", { cx: '18.4629', cy: '7.36573', r: '2.27052', stroke: color ? (0, colors_1.getColor)(color) : 'currentColor', strokeWidth: '1.5' })));
};
exports.Gallery = Gallery;
